export default __webpack_public_path__ + "static/media/freezer-hero.eedbbe1e.svg";